import React from 'react';

import { Text } from '@mantine/core';
import { useAuth } from 'context/auth-context';
import { useLocalization } from 'context/localization-context';
import dayjs from 'dayjs';
import { AthletePackageRetrieve, CreditDispensation } from 'types';
import { convertDateStringToDateObject, parseDateTimeToDate } from 'utils/date-functions';
import { TimeFrame } from 'utils/scheduling.helpers';

interface IValidityDatesCellProps {
  packageType: AthletePackageRetrieve['package']['type'];
  creditDispensation: CreditDispensation;
  pooledCredits?: number;
  timeFrame: TimeFrame;
  permission?: boolean;
}

const ValidityDatesCell = ({
  packageType,
  creditDispensation,
  pooledCredits,
  timeFrame,
}: IValidityDatesCellProps): JSX.Element => {
  const { dateFormat } = useLocalization();
  const { session } = useAuth();

  const timeFrameToTextProps = {
    past: { c: 'dimmed' },
    present: { fw: 'bold' },
    future: {},
  };

  let expirationDate = creditDispensation.expirationDate;
  let earlyCancel = false;
  if (!creditDispensation.isRollover && creditDispensation.athletePackageCancellationDate) {
    if (
      !creditDispensation.expirationDate ||
      dayjs(parseDateTimeToDate(creditDispensation.athletePackageCancellationDate, session?.gym?.timezone)) <
        dayjs(convertDateStringToDateObject(creditDispensation.expirationDate))
    ) {
      expirationDate = creditDispensation.athletePackageCancellationDate;
      earlyCancel = true;
    }
  }

  return (
    <>
      <Text {...timeFrameToTextProps[timeFrame]} style={{ whiteSpace: 'nowrap' }}>
        {creditDispensation.isRollover && <span style={{ marginRight: 4, display: 'inline-block' }}>↳</span>}
        {dayjs(convertDateStringToDateObject(creditDispensation.dispenseDate)).format(dateFormat)} -{' '}
        {expirationDate && (
          <>
            <>{dayjs(convertDateStringToDateObject(expirationDate)).format(dateFormat)}</>
            {packageType === 'TIME_OR_CREDIT_BASED' && !!pooledCredits && ` or ${pooledCredits} Credits`}
            {earlyCancel && <Text>Early Cancellation </Text>}
          </>
        )}
        {!expirationDate &&
          packageType === 'CREDIT_BASED' &&
          (creditDispensation.credits ? `${creditDispensation.credits} Credits` : '-')}
        {!expirationDate &&
          packageType === 'TIME_OR_CREDIT_BASED' &&
          (pooledCredits ? `${pooledCredits} Credits` : '-')}
        {!expirationDate && packageType === 'TIME_BASED' && 'None'}
      </Text>
    </>
  );
};

export default ValidityDatesCell;
